import { AfterViewInit, Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { ScreenService, paths } from '../shared/services/screen.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.sass'],
})
export class HomeComponent implements OnInit, AfterViewInit, OnDestroy {
  comdicaLogo!: string;
  navigation = 0;
  isMobileView = false;
  private readonly mobileBreakpoint = 900;
  private subscriptions = new Subscription();

  constructor(private screenService: ScreenService) {
    const navigate = sessionStorage.getItem('navigateTo');
    if (navigate !== null) {
      const parsed = Number(navigate);
      this.navigation = Number.isNaN(parsed) ? 0 : parsed;
    }
    sessionStorage.removeItem('navigateTo');
  }

  ngOnInit(): void {
    this.onResize();
    this.subscriptions.add(
      this.screenService.emitedValue$.subscribe((value) => this.navigateTo(value))
    );
  }

  ngAfterViewInit(): void {
    setTimeout(() => this.navigateTo(this.navigation, false));
  }

  @HostListener('window:resize', ['event'])
  onResize(event?: Event) {
    const wasMobileView = this.isMobileView;
    this.isMobileView = window.innerWidth < this.mobileBreakpoint;
    this.comdicaLogo = this.isMobileView
      ? 'assets/images/images/comdica-logo.svg'
      : 'assets/images/images/comdica-expanded-logo.svg';

    if (wasMobileView && !this.isMobileView) {
      this.navigateTo(this.navigation, false);
    }
  }

  navigateTo(value: number, smooth: boolean = true) {
    const maxIndex = paths.length - 1;
    const normalizedValue = Math.min(Math.max(value ?? 0, 0), maxIndex);
    this.navigation = normalizedValue;

    if (this.isMobileView) {
      requestAnimationFrame(() =>
        window.scrollTo({ top: 0, behavior: smooth ? 'smooth' : 'auto' })
      );
      return;
    }

    const anchorId = paths[this.navigation] ?? paths[0];

    requestAnimationFrame(() => {
      const anchor = document.getElementById(anchorId);
      const targetElement = this.resolveTargetElement(anchor);

      if (!targetElement) {
        if (!smooth) {
          window.scrollTo({ top: 0, behavior: 'auto' });
        }
        return;
      }

      const offset = this.getAnchorOffset();
      const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY;
      const top = Math.max(targetPosition - offset, 0);

      window.scrollTo({
        top,
        behavior: smooth ? 'smooth' : 'auto',
      });
    });
  }

  private resolveTargetElement(anchor: HTMLElement | null): HTMLElement | null {
    if (!anchor) {
      return null;
    }

    const styles = window.getComputedStyle(anchor);
    if (anchor.tagName === 'SPAN' || styles.visibility === 'hidden' || styles.display === 'none') {
      return (anchor.nextElementSibling as HTMLElement) ?? anchor;
    }

    return anchor;
  }


  private getAnchorOffset(): number {
    const expandedMenu = document.querySelector('.menu_expanded') as HTMLElement | null;
    if (expandedMenu && window.getComputedStyle(expandedMenu).display !== 'none') {
      return expandedMenu.offsetHeight + 24;
    }

    return 0;
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
